<mapfre-modal [modalOptions]="maintenanceModel"
    [hideModal]="hideModalOnRoute" (closeModal)="resetHideModal($event)">
    <div class="modal-body">
        <hr class="margin-bottom mb32 no-margin-top" />

              <div class="maintenance-sorry-page-services">
                <div class="head margin-bottom mb16">
                    {{ 'SERVICE_UNDER_MAINTENANCE' | translate}}
                </div>
              
                <div class="inprogress margin-bottom mb16">
                    {{ 'MAINTENANCE_INPROGRESS' | translate}}
                </div>
              
                <div class="hours">
                    <b>{{ 'MAINTENANCE_TIME' | translate}}</b>
                 </div>
              
                 <mapfre-button
                 [additionalClasses]="'basic default maintenance'"
                 [iconClasses]="'align-middle'"
                 (click)="resetHideModal(true)"
                  >  
                 {{ 'CLOSE' | translate }}
                </mapfre-button>
        </div>
    </div>
</mapfre-modal>